import { createRouter, createWebHistory } from 'vue-router'
import vuexStore from '../vuexStore/config.js'
import * as NAMESPACE_STORE from '../vuexStore/namespaceStore.js'
import themeComponent from '../views/ThemeSelector.vue'
import editorComponent from '../views/Editor.vue'
import compositionComponent from '../views/Composition.vue'
import loginComponent from '../views/Login.vue'
import registerComponent from '../views/Register.vue'

const routes = [
  {
    path: '/',
    redirect: '/theme'
  },
  {
    path: '/theme',
    name: 'ThemeSelector',
    component: themeComponent,
    meta: { requiresAuth: true }
  },
  {
    path: '/editor',
    name: 'Editor',
    component: editorComponent,
    meta: { requiresAuth: true, pageRequired: true, scale: "editor" }
  },
  {
    path: '/editor/composition/:siteId?',
    name: 'Composition',
    component: compositionComponent,
    meta: { requiresAuth: true, scale: "composition" }
  },
  {
    path: "/login",
    name: "Login",
    component: loginComponent,
    meta: { requiresAuth: false }
  },
  {
    path: "/register",
    name: "Register",
    component: registerComponent,
    meta: { requiresAuth: false }
  },
  {
    // Route catch-all pour rediriger les URLs inconnues vers ThemeSelector
    path: '/:pathMatch(.*)*',
    redirect: '/theme'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard pour vérifier l'authentification
router.beforeEach(async (to, from, next) => {
  if (to.meta.pageRequired) {
    let hasCurrentTheme = vuexStore.getters[`${NAMESPACE_STORE.THEME}/hasCurrentTheme`]
    if (!hasCurrentTheme) {
      next('/theme');
      return;
    }
  }
  if (to.meta.scale) {
    vuexStore.commit(`${NAMESPACE_STORE.THEME}/SET_USED_SCALE`, to.meta.scale);
  }
  // Vérifier si la route nécessite une authentification
  if (to.meta.requiresAuth) {
    // Récupérer l'état de connexion depuis le store Vuex
    let isLoggedIn = vuexStore.getters[`${NAMESPACE_STORE.USER}/isLoggedIn`]
    
    // Si pas connecté, vérifier avec le serveur
    if (!isLoggedIn) {
      try {
        await vuexStore.dispatch(`${NAMESPACE_STORE.USER}/checkAuth`)
        isLoggedIn = vuexStore.getters[`${NAMESPACE_STORE.USER}/isLoggedIn`]
      } catch (error) {
        console.error('Erreur lors de la vérification d\'authentification:', error)
      }
    }
    
    if (!isLoggedIn) {
      // Utilisateur non connecté, rediriger vers Login
      next('/login');
      return;
    } else {
      // Utilisateur connecté, autoriser l'accès
      next();
    }
  } else {
    // Route qui ne nécessite pas d'authentification
    next();
  }
})

export default router 